

import { Box, Drawer, List, styled, useTheme } from '@mui/material';
import { FC, ReactNode, useContext } from 'react';
import CommonContext from '../../contexts/data/CommonContext';

interface IMobileNavigationDrawerProps {
    navItems: ReactNode[]
}


const SpacingBox = styled(Box)(({ theme }) => ({
    ...theme.mixins.toolbar,
    height: 75
}));

const MobileNavigationDrawer: FC<IMobileNavigationDrawerProps> = ({
    navItems
}) => {

    //
    // -- Hooks --
    const theme = useTheme();

    //
    // -- Contexts -- 
    const { mobileNavigationDrawerOpen, setMobileNavigationDrawerOpen } = useContext(CommonContext);

    return (
        <Drawer
            anchor="right"
            open={mobileNavigationDrawerOpen}
            onClose={() => setMobileNavigationDrawerOpen(false)}
            hideBackdrop
            variant="persistent"
            sx={{
                width: '400px',
                [theme.breakpoints.down('lg')]: {
                    width: '100%',
                },
                flexShrink: 0,
                '&.MuiDrawer-docked': {
                    width: '0px !important'
                },
                '& .MuiDrawer-paper': {
                    width: '400px',
                    [theme.breakpoints.down('lg')]: {
                        width: '100%',
                    },
                    boxSizing: 'border-box',
                    backgroundColor: 'white',
                }
            }}
        >
            <SpacingBox />

            <List sx={{ display: 'flex', flexDirection: 'column', textDecoration: 'none !important' }}>
                {navItems}
            </List>
        </Drawer>
    );
}

export default MobileNavigationDrawer